import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL);

const defaultReturnUrl = () => {
    return window.location.search
        ? window.location.href + '&payment=success'
        : window.location.href + '?payment=success';
};

export const fetchPrice = (data = {}) => {
    return axios.post('/api/v1/payment_price/', data);
};

export const fetchLink = async (data, returnUrl = defaultReturnUrl()) => {
    const { redirect_url = '' } = await axios.post(`/api/v1/payments/`, data, {
        params: {
            redirect_url: returnUrl,
            success_url: returnUrl
        }
    });

    return redirect_url;
};

export const checkPayment = async receiptId => {
    if (!receiptId) {
        console.error('receiptId is undefined');
        return;
    }

    const { results } = await axios.get('/api/v1/payments/', {
        params: {
            receipt_id: receiptId
        }
    });

    const [log] = results;

    return log;
};
